import {
  LegislativnyMaterialHistoriaApi,
  StadiumMaterialuHistoriaList as StadiumMaterialuHistoriaListGenerated,
  StadiumMaterialuHistoria as StadiumMaterialuHistoriaGenerated,
} from 'evidencna-aplikacia-web-ts-axios';
import { evidenciaPrefixPath } from '../configuration/apiConfigurationConstants';
import apiConfiguration from '../configuration/apiConfiguration';
import { ClientResponse } from '../../model/ClientResponse';
import { mapStadium } from '../../model/StadiumMaterialu';
import Uuid from '../../model/Uuid';
import StadiumMaterialuHistoriaList from '../../model/StadiumMaterialuHistoriaList';
import StadiumMaterialuHistoria from '../../model/StadiumMaterialuHistoria';

const client = new LegislativnyMaterialHistoriaApi(apiConfiguration(evidenciaPrefixPath));

const mapStadiumMaterialuHistoria = (data: StadiumMaterialuHistoriaGenerated): StadiumMaterialuHistoria => ({
  uuid: data.uuid,
  stadium: mapStadium(data.stadium),
  datumZacatia: data.datumZacatia ? new Date(data.datumZacatia) : null,
  datumUkoncenia: data.datumUkoncenia ? new Date(data.datumUkoncenia) : null,
});

const map = (data: StadiumMaterialuHistoriaListGenerated): StadiumMaterialuHistoriaList => ({
  historiaRecords: data.historiaRecords.map(historiaRecord => mapStadiumMaterialuHistoria(historiaRecord)),
});

// eslint-disable-next-line import/prefer-default-export
export const getStadiumMaterialuHistoria = async (
  uuid: Uuid,
  options?: object,
): Promise<ClientResponse<StadiumMaterialuHistoriaList>> => {
  const {
    data,
    status,
  } = await client.getAllHistoriaRecords(uuid, options);
  return {
    data: map(data),
    responseCode: status,
  };
};
